<div class="group-share-wrapper">
  <!-- #region SHARED SCREEN -->
  <div
    class="share-screen-wrapper"
    [ngClass]="{
      'size-medium': !isFullScreen,
      'size-full-screen': isFullScreen,
      'drawer-open': isGalleryDrawerOpen,
      'captions-open': isCaptionsOpen,
      'is-sharing': isGroupSharing,
    }"
  >
    <div #videoWrapper class="video-wrapper">
      @if (isMobile) {
        @if (isFullScreenMobile) {
          <a class="close-fullscreen-mobile-button" (click)="handleFullscreenChange()">
            <mat-icon>close</mat-icon>
          </a>
        } @else {
          <a class="fullscreen-mobile-button" (click)="handleFullscreenChange()"> <mat-icon>fullscreen</mat-icon> </a>
        }
      } @else if (isPresentersDrawerOpen) {
        <a
          class="button-full-screen"
          (click)="toggleFullScreen()"
          [matTooltip]="isFullScreen ? 'Minimize' : 'Maximize'"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="{{ isFullScreen ? 'MINIMIZE' : 'MAXIMIZE' }}"></mat-icon>
        </a>
      }

      <div class="screen-share-video-fullscreen" [ngClass]="{ 'fullscreen-mobile-video-wrapper': isFullScreenMobile }">
        <video
          #videoElement
          id="screen-share-video"
          autoplay
          playsinline
          [muted]="isUserSharingScreen"
          [ngClass]="{ 'fullscreen-mobile': isFullScreenMobile }"
        ></video>
      </div>
      @if (popOutVideo && isVideoPlaying) {
        <div [ngClass]="{ 'groupshare-popout': !isScreenPopout, 'screenshare-group-popout': isScreenPopout }">
          <app-presentation-popout-button
            [videoElementToPopOut]="videoElement"
            [mode]="'SCREENSHARE'"
          ></app-presentation-popout-button>
        </div>
      }
      @if (fullScreenVideo && isVideoPlaying) {
        <div [ngClass]="{ 'groupshare-fullscreen': !fullScreenVideo }">
          <app-presentation-popout-button
            [videoElementToPopOut]="videoElement"
            [mode]="'SCREENSHARE'"
          ></app-presentation-popout-button>
        </div>
      }
      <div class="loading-container">
        <app-loading class="loading"></app-loading>
      </div>
    </div>
  </div>
  <!-- #endregion -->

  <!-- #region PRESENTER -->
  <div
    class="presentation-video-wrapper"
    [ngClass]="{
      'presentation-drawer-open': !!isGalleryDrawerOpen,
    }"
  >
    <div class="presentation-video-list">
      <div
        class="presentation-video-instance"
        [ngClass]="{
          'local-presenter': presentersPlayer?.userId === user?.userId && !isPresenterPopout,
          muted: videoMuted,
        }"
      >
        <div class="video-instance-border">
          @if (presenterEmote) {
            <div class="presenter-emote">
              <span class="emote-text">{{ presenterEmote.emote?.native ?? '' }}</span>
            </div>
          }
          <video #presenter (click)="toggleVideoDrawer($event)"></video>
          @if (videoMuted) {
            <img
              alt="video off"
              src="assets/images/video_off.svg"
              class="mute-indicator"
              (click)="toggleVideoDrawer($event)"
            />
          }
          @if (isPresentersDrawerOpen && roomHasRingColors && presentersPlayer?.ringColor) {
            <app-ring-colors-legend [ringContainerPosition]="{ left: '8px', top: '36px' }">
              <ng-container>
                <div class="visual-indicator">
                  <!--Mock for testing purposes -->
                  <div class="legend-dot" style="--color: {{ presentersPlayer?.ringColor }}"></div>
                </div>
              </ng-container>
            </app-ring-colors-legend>
          }
          @if (audioMuted && isPresentersDrawerOpen) {
            <div class="audio-muted-indicator" [ngClass]="{ audio_hover: popOutVideo && isPresentersDrawerOpen }">
              <mat-icon>mic_off</mat-icon>
            </div>
          }
          @if (popOutVideo && isPresentersDrawerOpen && !videoMuted) {
            <div [ngClass]="{ 'groupshare-popout': !isScreenPopout, 'presenter-group-popout': isPresenterPopout }">
              <app-presentation-popout-button
                [videoElementToPopOut]="presenter"
                [mode]="'PRESENTER'"
              ></app-presentation-popout-button>
            </div>
          }
          <div
            class="presenters-name"
            role="button"
            aria-label="Presenter's name"
            (click)="openBadge(presentersPlayer?.userId)"
          >
            <span>
              {{ formatPresentersName(presentersPlayer?.user) }}
            </span>
            <mat-icon [ngClass]="{ 'icon-presenters-size': !isGalleryDrawerOpen && isGroupSharing }">info</mat-icon>
          </div>
        </div>
      </div>
    </div>
    <button title="Open video drawer" type="button" class="drawer-button" (click)="toggleVideoDrawer($event)">
      <mat-icon svgIcon="ARROW_BACK"></mat-icon>
    </button>
  </div>
  <!-- #endregion -->
</div>
